import { render, staticRenderFns } from "./ConvenioDadosCadastrais.vue?vue&type=template&id=957daa82"
import script from "./ConvenioDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./ConvenioDadosCadastrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports